import React from 'react';

const DirectedTradeReportsModal = ({
  show,
  onClose,
  reportOptions,
  selectedReports,
  onToggleReport,
  onSelectAll,
  onClear,
  onRefresh,
  isFetching,
  isLoading,
  loadError,
}) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: 'block' }}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-cloud-download me-2"></i>
                Refresh Tamarac Bulk Reports
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                disabled={isFetching}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label fw-semibold mb-0">Reports To Refresh</label>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onSelectAll}
                    disabled={isLoading || !reportOptions.length || isFetching}
                  >
                    Select All
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onClear}
                    disabled={isLoading || !selectedReports.length || isFetching}
                  >
                    Clear
                  </button>
                </div>
              </div>

              {loadError ? (
                <div className="alert alert-danger py-2 mb-2" role="alert">
                  {loadError}
                </div>
              ) : (
                <div className="border rounded p-2" style={{ maxHeight: 300, overflowY: 'auto' }}>
                  {isLoading ? (
                    <div className="text-muted small">Loading report templates...</div>
                  ) : (
                    reportOptions.map((reportName) => {
                      const reportId = `bulk-report-${reportName.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
                      return (
                        <div className="form-check mb-1" key={reportName}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={reportId}
                            checked={selectedReports.includes(reportName)}
                            onChange={() => onToggleReport(reportName)}
                            disabled={isFetching}
                          />
                          <label className="form-check-label" htmlFor={reportId}>
                            {reportName}
                          </label>
                        </div>
                      );
                    })
                  )}
                </div>
              )}

              <div className="mt-2 text-muted small">
                {selectedReports.length} of {reportOptions.length || 0} selected.
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
                disabled={isFetching}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={onRefresh}
                disabled={isLoading || isFetching || !selectedReports.length || !!loadError}
              >
                {isFetching ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Fetching Reports...
                  </>
                ) : (
                  <>
                    <i className="bi bi-cloud-download me-2"></i>
                    Fetch Reports
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default DirectedTradeReportsModal;
